import { Avatar, Badge } from '@mela/design-system';

export function MelaIDCardMock() {
  return (
    <div className="bg-white border border-ink-200 rounded-lg p-4 shadow-card w-full max-w-[320px] -rotate-[1.5deg] transition-transform duration-base ease-mela group-hover:[transform:rotate(-0.5deg)_translateY(-4px)]">
      <div className="flex gap-3 items-start">
        <Avatar size="md" initials="SP" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 flex-wrap mb-0.5">
            <strong className="text-[14px] font-bold text-ink-900 -tracking-[0.01em]">
              Sneha Patel
            </strong>
            <Badge variant="verified">★ Verified</Badge>
          </div>
          <div className="text-[12px] text-ink-600 mb-0.5">Director · Patel Textiles</div>
          <div className="font-mono text-[11px] text-ink-500">@snehapatel · Surat</div>
        </div>
      </div>
      <div className="h-px bg-ink-200 my-3" />
      <p className="font-display text-[13px] leading-snug italic text-ink-800 mb-2.5">
        “Premium cotton blends for export to MENA.”
      </p>
      <div className="flex gap-1 flex-wrap">
        {['Textiles', 'Exports', 'Gujarat'].map((tag) => (
          <span
            key={tag}
            className="px-2 py-0.5 bg-bg-soft text-ink-700 border border-ink-200 rounded-sm text-[10px] font-medium"
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}
